import { render } from "./MyAccountMenu.vue?vue&type=template&id=7f67ad9a&scoped=true&lang=pug"
import script from "./MyAccountMenu.vue?vue&type=script&lang=ts"
export * from "./MyAccountMenu.vue?vue&type=script&lang=ts"

import "./MyAccountMenu.vue?vue&type=style&index=0&id=7f67ad9a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7f67ad9a"

export default script